import { IS_WHITE_LABEL } from '@/shared/environments';

export const TITLE_META_TAG = IS_WHITE_LABEL ? 'Video Translation Tool' : 'Rask';
